import { groupBy, uniqBy } from 'lodash-es'

// Types
import { IScheduledProductInfo } from '@/types/mall'

export function groupProductsByHour(productData: IScheduledProductInfo[]) {
  const groupedByHour = groupBy(productData, (item) => {
    const liveTime = new Date(item.liveTime)
    const year = liveTime.getFullYear()
    const month = String(liveTime.getMonth() + 1).padStart(2, '0')
    const date = String(liveTime.getDate()).padStart(2, '0')
    const hour = String(liveTime.getHours()).padStart(2, '0')
    return `${year}-${month}-${date} ${hour}:00`
  })

  const today = new Date()
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  const tomorrowStr = `${tomorrow.getFullYear()}-${String(tomorrow.getMonth() + 1).padStart(2, '0')}-${String(tomorrow.getDate()).padStart(2, '0')}`

  const productDataResult: { [key: string]: IScheduledProductInfo[] } = {}

  Object.keys(groupedByHour).forEach((key) => {
    const dateStr = key.split(' ')[0] // 取得日期部分
    const timeStr = key.split(' ')[1] // 取得時間部分

    // 排除 00:00 的時段
    if (timeStr === '00:00') return

    if (dateStr === todayStr) {
      const formattedKey = `${todayStr.replace(/-/g, '/')} ${timeStr}`
      // 使用 uniqBy 去除重複的 productId
      productDataResult[formattedKey] = uniqBy(groupedByHour[key], 'productInfo.productId')
    } else if (dateStr === tomorrowStr) {
      const formattedKey = `${tomorrowStr.replace(/-/g, '/')} ${timeStr}`
      // 使用 uniqBy 去除重複的 productId
      productDataResult[formattedKey] = uniqBy(groupedByHour[key], 'productInfo.productId')
    }
  })

  const todayKeys = Object.keys(productDataResult)
    .filter((key) => key.startsWith(todayStr.replace(/-/g, '/')))
    .sort()
  const tomorrowKeys = Object.keys(productDataResult)
    .filter((key) => key.startsWith(tomorrowStr.replace(/-/g, '/')))
    .sort()

  const todayTimes = todayKeys
    .map((fullTime) => {
      const { targetTime, isFuture } = getTargetTime(productDataResult, fullTime)

      const timeOnly = fullTime.split(' ')[1] // 取得 hh:mm 部分
      return { label: timeOnly, value: fullTime, targetTime, isFuture }
    })
    .filter(({ isFuture, targetTime }) => {
      if (isFuture) {
        return true
      } else {
        const nowTime = new Date().getTime()

        const endTime = new Date(targetTime || '').getTime()

        return nowTime < endTime
      }
    })

  const tomorrowTimes = tomorrowKeys.map((fullTime) => {
    const timeOnly = fullTime.split(' ')[1] // 取得 hh:mm 部分
    return { label: timeOnly, value: fullTime }
  })

  return {
    productData: productDataResult,
    timeList: {
      today: todayTimes,
      tomorrow: tomorrowTimes,
    },
  }
}

// 根據選擇的時間和當前時間，決定要取 endTime 還是 liveTime，並判斷是否為未來
export function getTargetTime(productData: { [key: string]: IScheduledProductInfo[] }, selectedStartTime: string) {
  if (!selectedStartTime || !productData[selectedStartTime]) {
    return { targetTime: null, isFuture: false }
  }

  const products = productData[selectedStartTime]
  const currentData = productData[selectedStartTime][0]

  const now = new Date()
  const currentDateLiveTime = new Date(currentData.liveTime)

  if (!products || products.length === 0) {
    return { targetTime: null, isFuture: false }
  }

  let targetTime: string | null = null
  let isFuture = false

  if (now > currentDateLiveTime) {
    targetTime = currentData?.roomInfo?.[0]?.endTime || null
    isFuture = false
  } else {
    targetTime = currentData?.liveTime || null
    isFuture = true
  }

  return {
    targetTime,
    isFuture,
    roomInfo: currentData?.roomInfo[0],
  }
}
